(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-fitness-editorial"] && !Shopify.designMode) return;
  try {
    
function initFitnessRibbons(root) {
  root.querySelectorAll('.pd-fit-edit__ribbonpause').forEach((button) => {
    if (button.dataset.ready) return;
    button.dataset.ready = '1';
    button.addEventListener('click', () => {
      const paused = button.getAttribute('aria-pressed') !== 'true';
      button.closest('.pd-fit-edit__ribbon').classList.toggle('is-paused', paused);
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
      button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
    });
  });
}
initFitnessRibbons(document);
document.addEventListener('shopify:section:load', (event) => initFitnessRibbons(event.target));
function initFitnessStories(root) {
  root.querySelectorAll('.pd-fit-edit__storyclose').forEach((button) => {
    if (button.dataset.ready) return;
    button.dataset.ready = '1';
    button.addEventListener('click', () => {
      const details = button.closest('.pd-fit-edit__storydetails');
      details.removeAttribute('open');
      details.querySelector('summary').focus({ preventScroll: true });
      details.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  });
}
initFitnessStories(document);
document.addEventListener('shopify:section:load', (event) => initFitnessStories(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-magazine"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('.pd-mag__strip-toggle');
  if (!button) return;
  const paused = button.closest('.pd-mag__strip').classList.toggle('is-paused');
  button.setAttribute('aria-pressed', String(paused));
  button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
  button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-music-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('.pdm__play');if(!button)return;const frame=button.parentElement;const iframe=document.createElement('iframe');iframe.src='https://www.youtube-nocookie.com/embed/'+button.dataset.videoId+'?autoplay=1&rel=0';iframe.title=button.dataset.videoTitle;iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';iframe.referrerPolicy='strict-origin-when-cross-origin';iframe.allowFullscreen=true;frame.replaceChildren(iframe)});
(function(){const root=document.querySelector('.pdm__game');if(!root)return;const canvas=root.querySelector('.pdm__snake-canvas');const ctx=canvas.getContext('2d');const scoreEl=root.querySelector('[data-pdm-score]');const statusEl=root.querySelector('[data-pdm-status]');const startBtn=root.querySelector('[data-pdm-start]');const pauseBtn=root.querySelector('[data-pdm-pause]');const grid=20;const cells=canvas.width/grid;let snake,dir,nextDir,ticket,score,timer,running,paused;function reset(){snake=[{x:8,y:10},{x:7,y:10},{x:6,y:10}];dir={x:1,y:0};nextDir={x:1,y:0};score=0;running=true;paused=false;placeTicket();scoreEl.textContent=score;statusEl.textContent='Tickets jagen. Keine Wand. Kein eigener Kopf.';draw();clearInterval(timer);timer=setInterval(tick,120)}function placeTicket(){do{ticket={x:Math.floor(Math.random()*cells),y:Math.floor(Math.random()*cells)}}while(snake&&snake.some(p=>p.x===ticket.x&&p.y===ticket.y))}function setDir(x,y){if(!running)return;if(dir.x+x===0&&dir.y+y===0)return;nextDir={x:x,y:y}}function tick(){if(!running||paused)return;dir=nextDir;const head={x:snake[0].x+dir.x,y:snake[0].y+dir.y};if(head.x<0||head.y<0||head.x>=cells||head.y>=cells||snake.some(p=>p.x===head.x&&p.y===head.y)){running=false;clearInterval(timer);statusEl.textContent='Game over. Noch eine Runde?';draw(true);return}snake.unshift(head);if(head.x===ticket.x&&head.y===ticket.y){score++;scoreEl.textContent=score;placeTicket()}else{snake.pop()}draw()}function draw(gameOver){ctx.clearRect(0,0,canvas.width,canvas.height);ctx.fillStyle='#0d0813';ctx.fillRect(0,0,canvas.width,canvas.height);ctx.strokeStyle='rgba(168,76,255,.18)';for(let i=0;i<=cells;i++){ctx.beginPath();ctx.moveTo(i*grid,0);ctx.lineTo(i*grid,canvas.height);ctx.moveTo(0,i*grid);ctx.lineTo(canvas.width,i*grid);ctx.stroke()}ctx.font='24px serif';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText('🎟️',ticket.x*grid+grid/2,ticket.y*grid+grid/2);snake.forEach((part,index)=>{ctx.font=index===0?'23px serif':'21px serif';ctx.fillText('💀',part.x*grid+grid/2,part.y*grid+grid/2)});if(gameOver){ctx.fillStyle='rgba(0,0,0,.62)';ctx.fillRect(0,canvas.height/2-44,canvas.width,88);ctx.fillStyle='#fff';ctx.font='900 34px Arial';ctx.fillText('GAME OVER',canvas.width/2,canvas.height/2)}}startBtn.addEventListener('click',reset);pauseBtn.addEventListener('click',function(){if(!running)return;paused=!paused;statusEl.textContent=paused?'Pause.':'Weiter geht die Ticketjagd.'});root.querySelectorAll('[data-pdm-dir]').forEach(btn=>btn.addEventListener('click',function(){const d=btn.dataset.pdmDir;if(d==='up')setDir(0,-1);if(d==='down')setDir(0,1);if(d==='left')setDir(-1,0);if(d==='right')setDir(1,0)}));document.addEventListener('keydown',function(e){const key=e.key.toLowerCase();if(['arrowup','w'].includes(key)){e.preventDefault();setDir(0,-1)}if(['arrowdown','s'].includes(key)){e.preventDefault();setDir(0,1)}if(['arrowleft','a'].includes(key)){e.preventDefault();setDir(-1,0)}if(['arrowright','d'].includes(key)){e.preventDefault();setDir(1,0)}});reset();paused=true;statusEl.textContent='Bereit. Drück Start und jag die Tickets.'})();

  } catch(e) { console.error(e); }
})();
})();
